export const ThemeService = {
    apply(theme) {
        if (!theme) return;

        const root = document.documentElement;

        Object.entries(theme).forEach(([key, value]) => {
            if (!value) return;

            root.style.setProperty(`--${key}`, value);
        });
    },

    reset() {
        document.documentElement.removeAttribute('style');
    }
}
